import React from 'react'

const FooterAuth = ({ classes, footerCopyRightClasses }) => {
  return (
    <div className={classes}>
      <a
        href="https://www.cometchat.com/legal-terms-of-service"
        target="_blank"
        rel="noopener noreferrer"
        className="mr-3"
      >
        Terms of Service
      </a>
      <a
        href="https://www.cometchat.com/contact-sales"
        target="_blank"
        rel="noopener noreferrer"
        className="mr-3"
      >
        Support
      </a>
      <div className={footerCopyRightClasses}> {new Date().getFullYear()} &copy; CometChat</div>
    </div>
  )
}

export default FooterAuth
